import { render, staticRenderFns } from "./WalletInformation.vue?vue&type=template&id=140fc40d&scoped=true&"
import script from "./WalletInformation.vue?vue&type=script&lang=js&"
export * from "./WalletInformation.vue?vue&type=script&lang=js&"
import style0 from "./WalletInformation.vue?vue&type=style&index=0&id=140fc40d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140fc40d",
  null
  
)

export default component.exports